import axios from '@/js/helper/axios-helper.js'
import { get } from 'lodash-es'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

/** TODO: Refactor */
import TYPES from './action-types'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

export const getActions = MUTATION_TYPES => ({
  [TYPES.FETCH_MESSAGES]: async ({ state, commit, rootGetters }, { method = 'GET' } = {}) => {
    const url = `${rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_LIST_URL}`]}`
    if (!url) {
      return Promise.reject(new Error(`Missing MESSAGES Url!`))
    }

    if (rootGetters[`${MUTATION_TYPES.MESSAGES.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.MESSAGES.promiseKey]
    }

    const params = {
      method,
      url: url || state[MUTATION_TYPES.MESSAGES.urlKey],
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.MESSAGES.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.MESSAGES.urlKey], null)
        }

        commit(MUTATION_TYPES.MESSAGES.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        return {} // Promise.reject(new Error(error.message)) - removed in order to fix issues logged in the Bugsnag console
      })

    commit(MUTATION_TYPES.MESSAGES.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.FETCH_UPDATE]: async (
    { state, commit, rootGetters, dispatch },
    { method = 'GET' } = {},
  ) => {
    const url = `${rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_UPDATE_URL}`]}`

    if (!url) {
      return Promise.reject(new Error(`Missing MESSAGES_UPDATE Url!`))
    }

    if (rootGetters[`${MUTATION_TYPES.MESSAGES_UPDATE.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.MESSAGES_UPDATE.promiseKey]
    }

    const params = {
      method,
      url: url || state[MUTATION_TYPES.MESSAGES_UPDATE.urlKey],
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.MESSAGES_UPDATE.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data && dispatch(TYPES.FETCH_MESSAGES)
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.MESSAGES_UPDATE.urlKey], null)
        }

        commit(MUTATION_TYPES.MESSAGES_UPDATE.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        return {} // Promise.reject(new Error(error.message)) - removed in order to fix issues logged in the Bugsnag console
      })

    commit(MUTATION_TYPES.MESSAGES_UPDATE.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.FETCH_STATUS]: async ({ state, commit, rootGetters }, { method = 'GET' } = {}) => {
    console.debug('MESSAGES.FETCH_STATUS')
    const url = rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_STATUS_URL}`]

    if (!url) {
      console.warn('Missing MESSAGES_STATUS Url!')
      commit(MUTATION_TYPES.MESSAGES_STATUS.BASE, {
        type: REQUEST_STATE.STATE_FAILURE,
        data: {},
        errorMessage: 'Missing MESSAGES_STATUS Url!',
      })

      return {}
      // return Promise.reject(new Error(`Missing MESSAGES_STATUS Url!`))
    }

    if (rootGetters[`${MUTATION_TYPES.MESSAGES_STATUS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.MESSAGES_STATUS.promiseKey]
    }

    const params = {
      method,
      url: url || state[MUTATION_TYPES.MESSAGES_STATUS.urlKey],
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.MESSAGES_STATUS.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.MESSAGES_UPDATE.urlKey], null)
        }

        commit(MUTATION_TYPES.MESSAGES_STATUS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        return {} // Promise.reject(new Error(error.message)) - removed in order to fix issues logged in the Bugsnag console
      })

    commit(MUTATION_TYPES.MESSAGES_STATUS.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.FETCH_MESSAGES_ATTACHMENTS]: async (
    { state, commit, rootGetters },
    { method = 'GET', uid } = {},
  ) => {
    const url = `${
      rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_ATTACHMENT_URL}`]
    }&uid=${uid}`

    if (!url) {
      return Promise.reject(new Error(`Missing MESSAGES_STATUS Url!`))
    }

    if (rootGetters[`${MUTATION_TYPES.MESSAGES_ATTACHMENTS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.MESSAGES_ATTACHMENTS.promiseKey]
    }

    const params = {
      method,
      url: url || state[MUTATION_TYPES.MESSAGES_ATTACHMENTS.urlKey],
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.MESSAGES_ATTACHMENTS.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.MESSAGES_UPDATE.urlKey], null)
        }

        commit(MUTATION_TYPES.MESSAGES_ATTACHMENTS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        return {} // Promise.reject(new Error(error.message)) - removed in order to fix issues logged in the Bugsnag console
      })

    commit(MUTATION_TYPES.MESSAGES_ATTACHMENTS.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.FETCH_MESSAGES_DETAIL]: async (
    { state, commit, rootGetters },
    { method = 'GET', uid } = {},
  ) => {
    const url = `${rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_DETAIL_URL}`]}&uid=${uid}`

    if (!uid) {
      return Promise.reject(new Error(`Missing uid for MESSAGE DETAIL!`))
    }

    if (!url) {
      return Promise.reject(new Error(`Missing MESSAGES_DETAIL Url!`))
    }

    if (rootGetters[`${MUTATION_TYPES.MESSAGES_DETAIL.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.MESSAGES_DETAIL.promiseKey]
    }

    const params = {
      method,
      url,
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.MESSAGES_DETAIL.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.MESSAGES_DETAIL.urlKey], null)
        }

        commit(MUTATION_TYPES.MESSAGES_DETAIL.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        return {} // Promise.reject(new Error(error.message)) - removed in order to fix issues logged in the Bugsnag console
      })

    commit(MUTATION_TYPES.MESSAGES_DETAIL.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.SET_CURRENT_MESSAGE_PREVIEW]: ({ commit }, data) => {
    commit(MUTATION_TYPES.SET_MESSAGE_PREVIEW_DATA, data)
  },
})
